import crud from './helpers/crud';

// The organization admin's SAML single sign-on settings (Api::V1::SamlConnectionsController).
// Every call answers the same payload: { saml_connection, service_provider, allowed_domains,
// users_outside_allowed_domains }.
const SAML_CONNECTION_URL = '/api/v1/saml_connection';

const getSamlConnection = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_SAML_CONNECTION',
      fail: 'FAILED_GET_SAML_CONNECTION',
      end: 'FINISH_GET_SAML_CONNECTION',
    },
    method: 'GET',
    url: SAML_CONNECTION_URL,
  })
);

// Starts setup: creates the connection whose Identifier and Reply URL go into Entra.
const createSamlConnection = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_CREATE_SAML_CONNECTION',
      fail: 'FAILED_CREATE_SAML_CONNECTION',
      end: 'FINISH_CREATE_SAML_CONNECTION',
    },
    method: 'POST',
    url: SAML_CONNECTION_URL,
  })
);

// changes: any of { metadata_url, metadata_xml, enabled, enforced }.
const updateSamlConnection = (changes) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_SAML_CONNECTION',
      fail: 'FAILED_UPDATE_SAML_CONNECTION',
      end: 'FINISH_UPDATE_SAML_CONNECTION',
    },
    method: 'PATCH',
    url: SAML_CONNECTION_URL,
    data: { saml_connection: changes },
  })
);

const deleteSamlConnection = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_DELETE_SAML_CONNECTION',
      fail: 'FAILED_DELETE_SAML_CONNECTION',
      end: 'FINISH_DELETE_SAML_CONNECTION',
    },
    method: 'DELETE',
    url: SAML_CONNECTION_URL,
  })
);

export {
  getSamlConnection,
  createSamlConnection,
  updateSamlConnection,
  deleteSamlConnection,
};
